<template>
    <section class="l-section l-section--main">
        <div
            class="l-container l-container--main"
            v-if="customer"
        >
            <cart-tabs />
            <div class="l-row">
                <div class="l-row__column l-row__column--10">
                    <cart-summary/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import CartSummary from '@/components/CartSummary'
import CartTabs from '@/components/CartTabs'

export default {
    metaInfo: {
        title: 'Podsumowanie'
    },
    components: {
        CartSummary,
        CartTabs
    },
    computed: {
        currentAddress() {
            return this.$store.getters.currentAddress
        },
        customer() {
            return this.$store.getters.customer
        }
    },
    methods: {
        handleResize() {
            // on desktop redirect to global route
            if(window.innerWidth > 1024) {
                this.$router.push({ name: 'cart' })
            }
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>
